// extracted by mini-css-extract-plugin
export default {"shadowed":"SinglePageRoutes_shadowed__6Xc7a","pageDivider":"SinglePageRoutes_pageDivider__lLGgi"};